import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { motion } from "framer-motion";
import HomePage from "./pages/HomePage";
import EventUploadPage from "./pages/EventUploadPage";
import GalleryPage from "./pages/GalleryPage";

const App = () => {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/"
            element={
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.6 }}
              >
                <HomePage />
              </motion.div>
            }
          />
          <Route
            path="/:eventId"
            element={
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.6 }}
              >
                <EventUploadPage />
              </motion.div>
            }
          />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
